// // src/services/stockManagementService.js
// import axiosInstance from './axiosConfig';

// const stockManagementService = {
//   // ========== CATEGORIES ==========
//   getActiveCategories: async () => {
//     const response = await axiosInstance.get('/categories/all');
//     return response.data.data ?? response.data;
//   },

//   getCategoriesForInventory: async (inventoryId) => {
//     const response = await axiosInstance.get(`/inventories/${inventoryId}/categories`);
//     return response.data.data ?? response.data;
//   },

//   // ========== INVENTORIES ==========
//   getActiveInventories: async () => {
//     const response = await axiosInstance.get('/inventories/active');
//     return response.data.data ?? response.data;
//   },

//   // ========== SUPPLIERS ==========
//   getActiveSuppliers: async () => {
//     const response = await axiosInstance.get('/suppliers/active');
//     return response.data.data ?? response.data;
//   },

//   // ========== PRODUCTS ==========
//  getProductsByCategory: async (categoryId, limit = 10000) => {
//   // getProductsByCategory: async (categoryId) => {
//   //   // Use the main products endpoint with category filter to get totalStock
//   //   const response = await axiosInstance.get(`/products?categoryId=${categoryId}`);
//   //   console.log('🔍 getProductsByCategory - Raw response:', response);
//   //   console.log('🔍 getProductsByCategory - response.data:', response.data);
//   //   console.log('🔍 getProductsByCategory - First product:', response.data.data?.[0]);
//   //   return response.data.data ?? response.data;
//   // },
// getProductsByCategory: async (categoryId, limit = 200) => {
//   // Use the main products endpoint with category filter to get totalStock
//   const response = await axiosInstance.get(`/products?categoryId=${categoryId}&limit=${limit}`);
//   console.log('🔍 getProductsByCategory - Raw response:', response);
//   console.log('🔍 getProductsByCategory - response.data:', response.data);
//   console.log('🔍 getProductsByCategory - First product:', response.data.data?.[0]);
//   return response.data.data ?? response.data;
// },

// // ========== STOCKS (Current Stock View) ==========
// getStockByInventoryAndProduct: async (inventoryId, productId) => {
//   const response = await axiosInstance.get(`/stocks/all?inventoryId=${inventoryId}&productId=${productId}`);
//   return response.data.data ?? response.data;
// },

//   getProductDetails: async (productId) => {
//     const response = await axiosInstance.get(`/products/${productId}`);
//     return response.data.data ?? response.data;
//   },

//   // ========== STOCKS (Current Stock View) ==========
//   getAllStocks: async (page = 1, limit = 10) => {
//     const response = await axiosInstance.get(`/stocks?page=${page}&limit=${limit}`);
//     return response.data.data ?? response.data;
//   },

//   // ========== STOCK IN ==========
//   getAllStockIn: async () => {
//     const response = await axiosInstance.get('/stocks');
//     return response.data.data ?? response.data;
//   },

//   getStockIn: async (page = 1, limit = 10) => {
//     const response = await axiosInstance.get(`/stocks?page=${page}&limit=${limit}`);
//     return response.data.data ?? response.data;
//   },

//   stockIn: async (payload) => {
//     const response = await axiosInstance.post('/stocks/stock-in', payload);
//     return response.data;
//   },

//   updateStockIn: async (stockInId, payload) => {
//     const response = await axiosInstance.put(`/stocks/stock-in/${stockInId}`, payload);
//     return response.data;
//   },

//   updateStockInQty: async (stockInId, qty) => {
//     const response = await axiosInstance.patch(`/stocks/stock-in/${stockInId}`, { qty });
//     return response.data;
//   },

//   reduceStockInQty: async (stockInId, qtyToReduce) => {
//     const response = await axiosInstance.patch(`/stocks/stock-in/${stockInId}/reduce`, { qty: qtyToReduce });
//     return response.data;
//   },

//   // ========== STOCK OUT ==========
//   getStockOut: async (page = 1, limit = 10) => {
//     const response = await axiosInstance.get(`/stocks?page=${page}&limit=${limit}`);
//     return response.data.data ?? response.data;
//   },

//   stockOut: async (payload) => {
//     const response = await axiosInstance.post('/stocks/stock-out', payload);
//     return response.data;
//   },

//   // ========== BULK OPERATIONS ==========
//   updateStockQuantity: async (payload) => {
//     const response = await axiosInstance.patch('/stocks/update-bulk/qty', payload);
//     return response.data;
//   },

//   // ========== STOCK MOVEMENTS (Movement Log View) ==========
//   getStocks: async (page = 1, limit = 10000) => {
//     const response = await axiosInstance.get(`/stocks/stock-record?page=${page}&limit=${limit}`);
//     console.log('🔍 SERVICE - Raw API response:', response);
//     console.log('🔍 SERVICE - response.data:', response.data);
//     console.log('🔍 SERVICE - response.data.data:', response.data.data);
//     return response.data.data ?? response.data;
//   }
// };

// export default stockManagementService;
// src/services/stockManagementService.js
import axiosInstance from './axiosConfig';

const stockManagementService = {
  // ========== CATEGORIES ==========
  getActiveCategories: async () => {
    const response = await axiosInstance.get('/categories/all');
    return response.data.data ?? response.data;
  },

  getCategoriesForInventory: async (inventoryId) => {
    const response = await axiosInstance.get(`/inventories/${inventoryId}/categories`);
    return response.data.data ?? response.data;
  },

  // ========== INVENTORIES ==========
  getActiveInventories: async () => {
    const response = await axiosInstance.get('/inventories/active');
    return response.data.data ?? response.data;
  },

  // ========== SUPPLIERS ==========
  getActiveSuppliers: async () => {
    const response = await axiosInstance.get('/suppliers/active');
    return response.data.data ?? response.data;
  },

  // ========== PRODUCTS ==========
 getProductsByCategory: async (categoryId, limit = 10000) => {
  // Use the main products endpoint with category filter to get totalStock
  const response = await axiosInstance.get(`/products?categoryId=${categoryId}&limit=${limit}`);
  console.log('🔍 getProductsByCategory - Raw response:', response);
  console.log('🔍 getProductsByCategory - response.data:', response.data);
  console.log('🔍 getProductsByCategory - First product:', response.data.data?.[0]);
  return response.data.data ?? response.data;
},

// ========== STOCKS (Current Stock View) ==========
getStockByInventoryAndProduct: async (inventoryId, productId) => {
  const response = await axiosInstance.get(`/stocks/all?inventoryId=${inventoryId}&productId=${productId}`);
  return response.data.data ?? response.data;
},

  getProductDetails: async (productId) => {
    const response = await axiosInstance.get(`/products/${productId}`);
    return response.data.data ?? response.data;
  },

  // ========== STOCKS (Current Stock View) ==========
  getAllStocks: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/stocks?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // ========== STOCK IN ==========
  getAllStockIn: async () => {
    const response = await axiosInstance.get('/stocks');
    return response.data.data ?? response.data;
  },

  getStockIn: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/stocks?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  stockIn: async (payload) => {
    const response = await axiosInstance.post('/stocks/stock-in', payload);
    return response.data;
  },

  updateStockIn: async (stockInId, payload) => {
    const response = await axiosInstance.put(`/stocks/stock-in/${stockInId}`, payload);
    return response.data;
  },

  updateStockInQty: async (stockInId, qty) => {
    const response = await axiosInstance.patch(`/stocks/stock-in/${stockInId}`, { qty });
    return response.data;
  },

  reduceStockInQty: async (stockInId, qtyToReduce) => {
    const response = await axiosInstance.patch(`/stocks/stock-in/${stockInId}/reduce`, { qty: qtyToReduce });
    return response.data;
  },

  // ========== STOCK OUT ==========
  getStockOut: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/stocks?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  stockOut: async (payload) => {
    const response = await axiosInstance.post('/stocks/stock-out', payload);
    return response.data;
  },

  // ========== BULK OPERATIONS ==========
  updateStockQuantity: async (payload) => {
    const response = await axiosInstance.patch('/stocks/update-bulk/qty', payload);
    return response.data;
  },

  // ========== STOCK MOVEMENTS (Movement Log View) ==========
  getStocks: async (page = 1, limit = 10000) => {
    const response = await axiosInstance.get(`/stocks/stock-record?page=${page}&limit=${limit}`);
    console.log('🔍 SERVICE - Raw API response:', response);
    console.log('🔍 SERVICE - response.data:', response.data);
    console.log('🔍 SERVICE - response.data.data:', response.data.data);
    return response.data.data ?? response.data;
  }
};

export default stockManagementService;
